import calculateTabService from '@services/requests/calculate-tab.service';
import { APP_TYPES } from "../../../app.config";
import { setCompressionZone } from '@reducers/options/panel/actions';
import { prepareState } from '@reducers/web-services/calculate/actions';
import { callErrorNotification } from '@components/Notification';
import { APP_TEXTS } from '@texts';
import { standardList } from '../../../app.values';
import { setActiveCombination } from '../loads/actions';

export const SET_CALCULATE_GRID_SELECTED_ITEM = 'SET_CALCULATE_GRID_SELECTED_ITEM';
export const SET_CALCULATE_GRID_SELECTED_NAIL_ITEM = 'SET_CALCULATE_GRID_SELECTED_NAIL_ITEM';
export const SET_CALCULATE_ANCHOR_IMAGE_SRC = 'SET_CALCULATE_ANCHOR_IMAGE_SRC';
export const SET_CALCULATE_NAIL_IMAGE_SRC = 'SET_CALCULATE_NAIL_IMAGE_SRC';
export const SET_CALCULATE_INSTALLATION_METHOD_IMAGE_SRC = 'SET_CALCULATE_INSTALLATION_METHOD_IMAGE_SRC';
export const SET_CALCULATE_INSTALLATION_DATA = 'SET_CALCULATE_INSTALLATION_DATA';
export const SET_CALCULATE_ERROR_MESSAGES = 'SET_CALCULATE_ERROR_MESSAGES';
export const SET_CALCULATE_WAITING_FOR_ERRORS = 'SET_CALCULATE_WAITING_FOR_ERRORS';

export const SET_FEM_CALCULATION = 'SET_FEM_CALCULATION';
export const SET_FEM_OPTIMIZATION = 'SET_FEM_OPTIMIZATION';
export const SET_FEM_OPTIONS = 'SET_FEM_OPTIONS';
export const SET_FEM_RESULTS = 'SET_FEM_RESULTS';
export const RESET_FEM_RESULTS = 'RESET_FEM_RESULTS';

export const SET_CALCULATE_STATE = 'SET_CALCULATE_STATE';
export const RESET_CALCULATE_STATE = 'RESET_CALCULATE_STATE';

export const SET_PROFILE_RESISTANCE = 'SET_PROFILE_RESISTANCE';

export const SCROLL_TO_SELECTED_RESULT = 'SCROLL_TO_SELECTED_RESULT';
export const SET_CALCULATE_FILTER = 'SET_CALCULATE_FILTER';
export const SET_CALCULATE_NAILS_FILTER = 'SET_CALCULATE_NAILS_FILTER';

export const SET_REPORT_PROJECT_NAME = 'SET_REPORT_PROJECT_NAME';
export const SET_REPORT_FASTENING_POINT = 'SET_REPORT_FASTENING_POINT';
export const SET_REPORT_LOCATION = 'SET_REPORT_LOCATION';
export const SET_REPORT_CONTACT_NAME = 'SET_REPORT_CONTACT_NAME';
export const SET_REPORT_COMPANY_NAME = 'SET_REPORT_COMPANY_NAME';
export const SET_REPORT_PHONE_NUMBER = 'SET_REPORT_PHONE_NUMBER';
export const SET_REPORT_MAIL_ADDRESS = 'SET_REPORT_MAIL_ADDRESS';
export const SET_REPORT_COMMENT = 'SET_REPORT_COMMENT';
export const SET_REPORT_LANGUAGE = 'SET_REPORT_LANGUAGE';
export const SET_REPORT_DIM_3D = 'SET_REPORT_DIM_3D';

/*
  Action creators
 */
export function setCalculateGridSelectedItem(value) {
  return (dispatch, getState) => {
    const { appType } = getState().main;

    dispatch({
      type: SET_CALCULATE_GRID_SELECTED_ITEM,
      value,
      appType
    });

    if (!value) return;

    let name, type, diameter = null;

    if (appType === APP_TYPES.REBAR_REINFORCEMENT) {
      name = value.DatabaseName;
      type = 1;
      diameter = value.Diameter;
    } else {
      name = value.AnchorInternalName;
      type = value.IndexType;
      diameter = value.IndexDiameter;
    }

    if (!name) return;

    calculateTabService.getAnchorImageSrc(name, appType).then(src => {
      dispatch({
        type: SET_CALCULATE_ANCHOR_IMAGE_SRC,
        appType,
        imageSrc: src
      });
    });

    calculateTabService.getInstallationData(name, diameter, type).then(res => {
      dispatch({
        type: SET_CALCULATE_INSTALLATION_DATA,
        appType,
        value: res
      });
    });

    if (appType === APP_TYPES.REBAR_REINFORCEMENT) {
      let err = [];

      if (value.OutMessage) {
        err.push(...value.OutMessage);
      }

      if (value.FireCalculation && value.FireOutMessage) {
        err.push(...value.FireOutMessage);
      }

      dispatch({
        type: SET_CALCULATE_ERROR_MESSAGES,
        appType,
        value: err
      });
    } else {
      if (Number(getState().main.localization.designStandard) !== standardList['ICC.Cast']) {
        calculateTabService.getInstallationMethod(name).then(src => {
          dispatch({
            type: SET_CALCULATE_INSTALLATION_METHOD_IMAGE_SRC,
            appType,
            imageSrc: src
          });
        });
      }

      dispatch({
        type: SET_CALCULATE_WAITING_FOR_ERRORS,
        appType,
        value: true
      });
      calculateTabService.getResultErrorMessages(name, diameter, type).then(res => {
        dispatch({
          type: SET_CALCULATE_ERROR_MESSAGES,
          appType,
          value: res
        });
      });

      dispatch(setCompressionZone(
        value.HasCompressionZone,
        value.TensionZone,
        value.CompressionZone,
        {
          P1: {
            x: value.NeutralAxisP1X,
            y: value.NeutralAxisP1Y
          },
          P2: {
            x: value.NeutralAxisP2X,
            y: value.NeutralAxisP2Y
          }
        }));

      if (appType === APP_TYPES.GENERAL_CALCULATION) {
        let loadCombinations = getState().selectors.loads[getState().main.appType].designLoadingData;
        let loadIdx = loadCombinations ? loadCombinations.findIndex(c => c.name === value.NameOfCombination) : -1;
        if (loadIdx >= 0) {
          dispatch(setActiveCombination(loadIdx));
        }
      }

      dispatch(resetFEMResults());
    }
  };
}

export function setCalculateGridSelectedNailItem(value) {
  return (dispatch, getState) => {
    if (!value) return;

    const { appType } = getState().main;

    dispatch({
      type: SET_CALCULATE_GRID_SELECTED_NAIL_ITEM,
      value,
      appType
    });

    calculateTabService.getNailImageSrc(value.NailInternalName).then(src => {
      dispatch({
        type: SET_CALCULATE_NAIL_IMAGE_SRC,
        appType,
        imageSrc: src
      });
    });
  };
}

export function setFEMCalculation(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_FEM_CALCULATION, appType: getState().main.appType, value });
  };
}

export function setFEMOptimization(value) {
  return (dispatch, getState) => {
    dispatch(resetFEMResults());
    dispatch({ type: SET_FEM_OPTIMIZATION, appType: getState().main.appType, value });
  };
}

export function setFEMOptions(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_FEM_OPTIONS, appType: getState().main.appType, options: value });
  };
}

export function startFEMCalculation() {
  return async (dispatch, getState) => {
    const appType = getState().main.appType;
    if (appType !== APP_TYPES.REBAR_REINFORCEMENT) {
      dispatch(setFEMCalculation(true));
      dispatch(resetFEMResults());
      await calculateTabService.runFEMCalculation(prepareState(getState()), appType)
        .then(res => {
          if (res && res.hasOwnProperty("IsValid")) {
            if (res.IsValid) {
              dispatch({ type: SET_FEM_RESULTS, appType, results: res });
            } else {
              callErrorNotification(APP_TEXTS.NOTIFICATIONS_FEM_CALCULATION_CANCELLED.Content);
            }
          }
        });

      dispatch(setFEMCalculation(false));
    }
  };
}

export function cancelFEMCalculation() {
  return (dispatch) => {
    dispatch(resetFEMResults());
    calculateTabService.cancelFEMCalculation().then();
  };
}

export function resetFEMResults() {
  return (dispatch, getState) => {
    dispatch({ type: RESET_FEM_RESULTS, appType: getState().main.appType });
  };
}

export function resetCalculateState() {
  return { type: RESET_CALCULATE_STATE };
}
export function setCalculateState(state) {
  return { type: SET_CALCULATE_STATE, state };
}

export function setProfileResistance(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PROFILE_RESISTANCE, value, appType: getState().main.appType });
  };
}

export function scrollToSelectedResult(value) {
  return (dispatch, getState) => {
    dispatch({ type: SCROLL_TO_SELECTED_RESULT, value, appType: getState().main.appType });
  };
}

export function setCalculateFilter(type, value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CALCULATE_FILTER, filterType: type, filterValue: value, appType: getState().main.appType });
  };
}

export function setCalculateNailsFilter(type, value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CALCULATE_NAILS_FILTER , filterType: type, filterValue: value, appType: getState().main.appType });
  };
}

export function getErrorMessages(result) {
  return (dispatch, getState) => {
    let name = result.AnchorInternalName;
    let type = result.IndexType;
    let diameter = result.IndexDiameter;
    calculateTabService.getResultErrorMessages(name, diameter, type).then(res => {
      dispatch({
        type: SET_CALCULATE_ERROR_MESSAGES,
        appType: getState().main.appType,
        value: res
      });
    });
  };
}

export function setReportProjectName(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_PROJECT_NAME, value });
  };
}
export function setReportFasteningPoint(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_FASTENING_POINT, value });
  };
}
export function setReportLocation(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_LOCATION, value });
  };
}
export function setReportContactName(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_CONTACT_NAME, value });
  };
}
export function setReportCompanyName(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_COMPANY_NAME, value });
  };
}
export function setReportPhoneNumber(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_PHONE_NUMBER, value });
  };
}
export function setReportMailAddress(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_MAIL_ADDRESS, value });
  };
}
export function setReportComment(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_COMMENT, value });
  };
}
export function setReportLanguage(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_LANGUAGE, value });
  };
}
export function setReportDimensions3D(value) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT_DIM_3D, value });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/calculate/actions.js